export const createLanguageRegionLocale = (locale: string) => {
  if (locale.length === 2) {
    return `${locale}-CH`
  } else return locale
}
